exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-fix-page[data-v-720e7d04]{padding-bottom:7em;padding-top:4em}@media (min-width:641px){.loginBorder[data-v-720e7d04]{border:solid;border-width:7px;border-radius:20px;border-top:none;border-color:#8cc63f;padding:55px}}@media (max-width:576px){.loginBorder[data-v-720e7d04]{border:solid;border-width:7px;border-radius:20px;border-top:none;border-color:#8cc63f;padding:25px 10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-720e7d04","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/pages/login.vue
// module id = 206
// module chunks = 0